import type { ListTableColumnSortBy } from "../../types";

export function getNexSortBy(
  currentSortBy?: ListTableColumnSortBy
): ListTableColumnSortBy | undefined {
  if (currentSortBy === undefined) return "asc";
  if (currentSortBy === "asc") return "desc";
  // if currently "desc", return to neutral (undefined)
  return undefined;
}
